import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import TaskPanelHeaderAsExec from '../_common/TaskPanelHeaderAsExec';
import TaskPanelBodyAsExec from '../_common/TaskPanelBodyAsExec';

// eslint-disable-next-line react/prefer-stateless-function
class TaskInfoBlockAsExecutor extends Component {
  render() {
    return (
      <article className="panel task task_detailed panel-default">
        <TaskPanelHeaderAsExec task={this.props.task} typeLayout={`view`} />
        <div className="panel-body">
          <TaskPanelBodyAsExec task={this.props.task} />
        </div>
        <div className="panel-footer panel-inner-border-top">
          <div className="hor-scroll hor-scroll_always">
            <div className="hor-scroll-wrapper">
              <NavLink
                to={`/earn-money/task-view/${this.props.task.id}/executions`}
                className="counter"
                data-container="body"
                data-placement="top"
                data-toggle="tooltip"
                title=""
                data-original-title={
                  this.props.task.tasksExecsStat.statuses[4].execStatusTitle
                }
              >
                <div className="counter-val text-success">
                  {this.props.task.tasksExecsStat.statuses[4].execCountByStatus}
                </div>
                <div className="counter-label">{t('Оплачено')}</div>
              </NavLink>
              <NavLink
                to={`/earn-money/task-view/${this.props.task.id}/executions`}
                className="counter"
                data-container="body"
                data-placement="top"
                data-toggle="tooltip"
                title=""
                data-original-title={
                  this.props.task.tasksExecsStat.statuses[2].execStatusTitle
                }
              >
                <div className="counter-val">
                  {this.props.task.tasksExecsStat.statuses[2].execCountByStatus}
                </div>
                <div className="counter-label">{t('На проверке')}</div>
              </NavLink>
              <NavLink
                to={`/earn-money/task-view/${this.props.task.id}/executions`}
                className="counter"
                data-container="body"
                data-placement="top"
                data-toggle="tooltip"
                title=""
                data-original-title={
                  this.props.task.tasksExecsStat.disputesFromExecutors.desc
                }
              >
                <div className="counter-val text-danger">
                  {this.props.task.tasksExecsStat.disputesFromExecutors.count}
                </div>
                <div className="counter-label">{t('Отказано')}</div>
              </NavLink>
              <NavLink
                to={`/earn-money/task-view/${this.props.task.id}/reviews/likes`}
                className="counter"
                data-container="body"
                data-placement="top"
                data-toggle="tooltip"
                title=""
                data-original-title={t('Положительные отзывы')}
              >
                <div className="counter-val text-muted">
                  {this.props.task.taskCommentsStat.likes}
                </div>
                <div className="counter-label">
                  <i className="fa fa-thumbs-o-up text-info" /> {t('Отзывы')}
                </div>
              </NavLink>
              <NavLink
                to={`/earn-money/task-view/${this.props.task.id}/reviews/dislikes`}
                className="counter"
                data-container="body"
                data-placement="top"
                data-toggle="tooltip"
                title=""
                data-original-title={t('Отрицательные отзывы')}
              >
                <div className="counter-val text-muted">
                  {this.props.task.taskCommentsStat.dislikes}
                </div>
                <div className="counter-label">
                  <i className="fa fa-thumbs-o-down text-info" /> {t('Отзывы')}
                </div>
              </NavLink>
            </div>
          </div>
        </div>
      </article>
    );
  }
}

TaskInfoBlockAsExecutor.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    taskCommentsStat: PropTypes.shape({
      dislikes: PropTypes.number.isRequired,
      likes: PropTypes.number.isRequired,
      neutral: PropTypes.number.isRequired
    }).isRequired,
    tasksExecsStat: PropTypes.shape({
      statuses: PropTypes.shape({}).isRequired,
      disputesFromExecutors: PropTypes.shape({
        desc: PropTypes.string,
        count: PropTypes.number
      }).isRequired
    }).isRequired,
    statFinishedExecs: PropTypes.number.isRequired
  }).isRequired
};

export default withRouter(TaskInfoBlockAsExecutor);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskView/TaskInfoBlockAsExecutor.js